// extracted by mini-css-extract-plugin
var _1 = "spin--zFiF1";
var _2 = "spinner--wOrP7";
export { _1 as "spin", _2 as "spinner" }
